import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from '@phosphor-icons/react';
import { motion } from '@/lib/motion';
import { useData } from '../data/DataProvider';
import { getSrcSet, SIZES } from '../utils/responsiveImage';

export const ServicesSection = () => {
  const { services } = useData();

  return (
    <section id="services" className="py-16 md:py-20 bg-gallery" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header - Centered */}
        <div className="text-center mb-10">
          <span className="label-architectural text-bronze">WHAT WE DO</span>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-obsidian mt-2">
            FOUR PILLARS OF EXCELLENCE
          </h2>
        </div>

        {/* Services Grid - 2x2 */}
        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {services.map((service, index) => (
            <motion.div
              key={service.id || index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <Link
                to={`/services/${index + 1}`}
                className="group relative block aspect-[4/3] overflow-hidden"
                data-testid={`service-card-${index}`}
              >
                <img loading="lazy" decoding="async"
                  src={service.image} 
                  srcSet={getSrcSet(service.image)}
                  sizes={SIZES.fourCol}
                  alt={service.title}
                  width={800}
                  height={600}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-obsidian/30 to-transparent" />
                <div className="absolute inset-0 p-4 md:p-6 flex flex-col justify-end">
                  <span className="label-architectural text-white/50 text-[10px] mb-1">0{index + 1}</span>
                  <h3 className="font-display text-sm md:text-lg font-bold text-white group-hover:text-bronze transition-colors">
                    {service.title}
                  </h3>
                </div>
                <div className="absolute top-3 right-3 md:top-4 md:right-4 w-8 h-8 md:w-10 md:h-10 border border-white/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity group-hover:bg-white">
                  <ArrowUpRight weight="bold" className="w-3 h-3 md:w-4 md:h-4 text-white group-hover:text-obsidian" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
